import { render } from "./DotsMenu.vue?vue&type=template&id=62c60614"
import script from "./DotsMenu.vue?vue&type=script&lang=js"
export * from "./DotsMenu.vue?vue&type=script&lang=js"
script.render = render

export default script